import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainAndSolutions } from '../components/PainAndSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { OfferSection } from '../components/OfferSection';
import { ObjectionsAndCTA } from '../components/ObjectionsAndCTA';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="w-full min-h-screen" style={{
    backgroundColor: 'var(--cream)'
  }} data-id="element-291">
      <HeroSection data-id="element-292" />
      <PainAndSolutions data-id="element-293" />
      <MechanismSection data-id="element-294" />
      <OfferSection data-id="element-295" />
      <ObjectionsAndCTA data-id="element-296" />
      <Footer data-id="element-297" />
    </div>;
}